import CountdownTimer from "@/components/financials/CountdownTimer";

const FinancialStatements = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <CountdownTimer />
      <div className="bg-card rounded-lg p-6">
        <p className="text-muted-foreground">
          Financial statements content will be displayed here.
        </p>
      </div>
    </div>
  );
};

export default FinancialStatements;